import React, { useState, useCallback } from "react"
import { Drawer } from "antd"
import { DeviceProfileForm } from "~/components"

const useDeviceProfile = ({
  deviceProfile,
  loading = false,
  width = "60%",
  onClose,
  onSubmit,
  onRemove,
} = {}) => {
  const [visible, setVisible] = useState(false)
  const show = () => setVisible(true)
  const hide = () => setVisible(false)
  const onCancel = () => {
    onClose && onClose()
    hide()
  }

  const DeviceProfileDrawer = useCallback(() => {
    return (
      <Drawer
        width={width}
        closeIcon={null}
        keyboard={false}
        title={"Product"}
        open={visible}
        onClose={onCancel}
      >
        <DeviceProfileForm
          id={deviceProfile?.id}
          initialValues={deviceProfile}
          onSubmit={onSubmit}
          onRemove={onRemove}
          onCancel={onCancel}
          loading={loading}
        />
      </Drawer>
    )
    // eslint-disable-next-line
  }, [visible])

  return {
    visible,
    show,
    hide,
    DeviceProfileDrawer,
  }
}

export default useDeviceProfile
